import { formatCustomDate } from "helpers/dateTools"

export const initialValues = {
  name: '',
  customerSearch: "",
  // customersOpt: [],
  customerSelected: "",
  plates: "",
  initialMileage: "",
  registrationDate: formatCustomDate(new Date(), '-'),
  idTag: '',
  stationsOpt: [],
  stationsSelected: [],
  unitsOpt: [],
  unitsSelected: [],
}

export const fieldValidations = {
  "plates": {
    "required": true
  },
  "initialMileage": {
    "required": true
  },
}
  